
<div class="p-grid" *ngIf="showTitle">    
  <div class="p-col-5"></div>
  <div class="p-col-2 summary-data summary-data {{headerClass}}" (click)="loadSummary()">
    <i [ngClass]="showSummary ? 'fas fa-chevron-down' : 'fas fa-chevron-up'"></i>Show Summary
  </div> 
  <div class="p-col-5"></div>
</div>
<p-card styleClass="ui-card-shadow" *ngIf="showSummary">
  <div class="ui-progressSpinner">
      <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="1" *ngIf="loading"></p-progressSpinner>
  </div>
  <div class="p-grid"> 
      <div class="p-col-2" *ngFor="let header of headerSummaryData">
        <span class="property-header-label">{{header.Label}}</span><br/>
        <span class="property-header-values">{{header.Value}}
        <i class="fa fa-info-circle" aria-hidden="true"
        *ngIf="header.DetailDisplayConfigId" 
        (mouseover)="loadChangeLogData($event,header.DetailDisplayConfigId)" 
        (mouseout)="hideChangeLogPopup()" 
        (click)="hideChangeLogPopup()"
        ></i>

        </span>
      </div>
  </div>
</p-card>
<app-changelog-hoverover 
  [displayConfigurationId]="displayConfigurationId" 
  [event]="event"
  *ngIf="displayChangelog">
</app-changelog-hoverover>